import React, { useState } from 'react';
import { Redirect } from "react-router-dom";
import UserService from '../../services/user';
import { Card, Notification } from "rbx";
import { cpfOrCnpjMask, celPhoneMask, unMask } from '../../commons/masks';
import Controls from '../components/Controls/Controls';
import useForm from '../components/useForm';

const roles = [
  { label: 'Suporte', value: 'support' }, 
  { label: 'Administrador', value: 'adm' }
]

const UserForm = ({ newRecord=false, editRecord=false }) => {
  const [redirectTo, setRedirectTo] = useState('');
  const user = JSON.parse(sessionStorage.getItem('user'));

  const initialFormValues = {
    role: '',
    cpf_cnpj: newRecord ? '' : cpfOrCnpjMask(user.cpf_cnpj),
    name: newRecord ? '' : user.name,
    email: newRecord ? '' : user.email,
    birthday: '',
    phone: newRecord ? '' : celPhoneMask(user.phone),
    password: '',
    passwordNew: '',
    passwordConfirmation: ''
  }

  const {
    values,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm(initialFormValues);

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStatus('');
    setStateButton("loading");
    try {

      if (newRecord) { // New Record
         const data = {
          role: values.role,
          cpf_cnpj: unMask(values.cpf_cnpj),
          name: values.name,
          email: values.email,
          phone: unMask(values.phone),
          password: values.password
        }
        const response = await UserService.register(data);
        setStatus(['success', `${response.status}: ${response.data.message}`]);

      } else { // Edit Record

        if (values.passwordNew && values.passwordNew !== values.passwordConfirmation) {
          setStatus(['danger', 'As senhas não coincidem']);
        } else {
           const data = {
            cpf_cnpj: unMask(values.cpf_cnpj),
            name: values.name,
            email: values.email,
            phone: unMask(values.phone),
            password: values.password,
            passwordNew: values.passwordNew
          }
          await UserService.update(data);
          await UserService.logout();
        }

      }
    } catch (e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e}`]);
    }
    setStateButton('');
  }

  if (redirectTo)
    return <Redirect to={{pathname: redirectTo}} />

  const goToFind = () => setRedirectTo('/dashbord');

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <Card.Header>
          <Card.Header.Title>{newRecord ? 'Registrar Usuário do Sistema' : 'Minhas Informações Pessoais'}</Card.Header.Title>
        </Card.Header>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          {
            (newRecord) &&
              <Controls.RadioButton 
                name="role"
                radios={roles}
                onChange={handleInputChange}
                required
              />
          }
          <Controls.CpfCnpjField 
            label="CPF ou CNPJ"
            name="cpf_cnpj"
            placeholder='123.456.789-01'
            value={values.cpf_cnpj}
            onChange={handleInputChange}
            focus={true}
            required
          />
          <Controls.TextField 
            label="Nome"
            name="name"
            placeholder='Nome completo'
            value={values.name}
            onChange={handleInputChange}
            required
          />
          <Controls.TextField 
            label="Email"
            name="email"
            placeholder='nome@email.com'
            value={values.email}
            onChange={handleInputChange}
            required
          />
          <Controls.PhoneField 
            label="Telefone"
            name="phone"
            placeholder='(__) ____-____'
            value={values.phone}
            onChange={handleInputChange}
            required
          />
          <Controls.PasswordField 
            label={newRecord ? 'Senha:' : 'Senha Atual'}
            name="password"
            value={values.password}
            onChange={handleInputChange}
            required
          />
          <Controls.ActionButtons
            linkName="Cancelar" 
            handleClickBack={goToFind} 
            buttonState={stateButton} 
            buttonName={newRecord ? 'Registrar' : 'Atualizar'}
          />
        </Card.Content>
      </Card>
      {
        (editRecord) &&
        <>
          <br />
          <Card>
            <Card.Content>
              { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
              <Controls.PasswordField 
                label="Nova senha do Usuário"
                name="passwordNew"
                placeholder="Deixe em branco para não trocar a senha"
                value={values.passwordNew}
                onChange={handleInputChange}
              />
              <Controls.PasswordField 
                label="Confirme a nova senha"
                name="passwordConfirmation"
                placeholder="Deixe em branco para não trocar a senha"
                value={values.passwordConfirmation}
                onChange={handleInputChange}
              />
              <Controls.ActionButtons
                linkName="Cancelar" 
                handleClickBack={goToFind}
                buttonState={stateButton} 
                buttonName='Atualizar'
              />
            </Card.Content>
          </Card>
        </>
      }
    </form>
  )

}

export default UserForm;

